import styled from 'styled-components';

import { Column, Row, Ellipsis, media } from '@simplywallst/ui-core';

export const SearchResultWrapper = styled('div')`
  text-decoration: none;
`;

export const SearchResultRow = styled('div')`
  position: relative;
  display: flex;
  height: 64px;
  border-bottom: 1px solid ${({ theme }) => theme.color.spaceGrayRGBA(0.1)};
  align-items: center;
  padding-bottom: ${({ theme }) => theme.x0spacePx}px;
  cursor: pointer;
  user-select: none;

  ${media.mdUp`
    &:hover {
      background-color: ${({ theme }) => theme.color.paperRGBA(0.9)};
    }
  `}

  [aria-selected='true'] & {
    background-color: ${({ theme }) => theme.color.darkGrayRGBA(0.1)};
  }
`;

export const DetailsColumn = styled('div')`
  padding-left: 12px;
  padding-top: 0px;
  max-width: 350px;
`;

export const MiscColumn = styled('div')`
  padding-top: 8px;
  width: 80px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

export const NameContainer = styled('div')`
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  width: 100%;
`;

export const Title = styled('h4')`
  margin: 0;
  ${Ellipsis};
  ${media.mdUp`
    ${({ theme }) => theme.typography.smallStrong};
  `}

  ${media.mdDown`
    ${({ theme }) => theme.typography.baseStrong};
  `}

  color: ${({ theme }) => theme.color.spaceGray};
`;

export const UniqueSymbol = styled('p')`
  margin: 0;
  font-size: ${({ theme }) => theme.typography.tiny};
  color: ${({ theme }) => theme.color.spaceGrayRGBA(0.8)};
`;

export const ListingColumn = styled(Column)`
  border-bottom: 1px solid ${({ theme }) => theme.color.spaceGrayRGBA(0.1)};
  padding-bottom: ${({ theme }) => theme.x1spacePx}px;
`;

export const ListingRow = styled(Row)`
  background-color: 'transparent';
`;
